/**
 * Parse JSON-array fields that may be stored as an array, a JSON string,
 * or a double-encoded JSON string (stringifying an already-stringified value).
 */
export function parseJsonArray(rawValue) {
  if (rawValue == null || rawValue === '') return [];
  let value = rawValue;
  for (let i = 0; i < 3; i += 1) {
    if (Array.isArray(value)) {
      return value.map(item => (item == null ? '' : item));
    }
    if (typeof value !== 'string') return [];
    const trimmed = value.trim();
    if (!trimmed) return [];
    try {
      value = JSON.parse(trimmed);
    } catch {
      return [];
    }
  }
  return Array.isArray(value) ? value : [];
}
